import React from 'react';
import EntryCard from './EntryCard';

function EntriesList({ entries, onEdit, onDelete, loading, deletingId }) {
  if (loading) {
    return (
      <div className="entries-list loading">
        <span className="spinner"></span>
        <p>Loading entries...</p>
      </div>
    );
  }

  if (entries.length === 0) {
    return (
      <div className="entries-list empty">
        <p>No entries yet. Be the first to add your info!</p>
      </div>
    );
  }

  return (
    <div className="entries-list">
      <h2>Friendsgiving Attendees ({entries.length})</h2>
      <div className="entries-grid">
        {entries.map(entry => (
          <EntryCard
            key={entry.id}
            entry={entry}
            onEdit={onEdit}
            onDelete={onDelete}
            isDeleting={deletingId === entry.id}
          />
        ))}
      </div>
    </div>
  );
}

export default EntriesList;

